/**
 * Getters for documents
 *
 * @category Store
 * @subcategory Documents
 * @module Documents
 * @name Getters_Search
 * @type {object}
 * @getter  {Array<object>} DRIVES_I_CAN_COPY_ITEMS_TO=Array of drives current user may copy documents to
 */

export default {
  SEARCH_TERM: state => driveId => {
    const driveIdOrWorld = driveId || "world";
    return state.searchSetMap[driveIdOrWorld] ? state.searchSetMap[driveIdOrWorld].searchTerm : "";
  },
  SEARCH_ITEM_ID: state => driveId => {
    const driveIdOrWorld = driveId || "world";
    return state.searchSetMap[driveIdOrWorld] ? state.searchSetMap[driveIdOrWorld].itemId : null;
  },

  SEARCH_RESULTS: state => driveId => {
    const driveIdOrWorld = driveId || "world";
    return state.searchSetMap[driveIdOrWorld] ? state.searchSetMap[driveIdOrWorld].searchResults : [];
  }
};
